<template>
    <div>
      <v-container fluid>
          <v-row>
  
              <v-col cols="12" sm="12">
                  <div class="custom-question-msg">
                        <div class="line-height-20"> Out of the {{data.allQuestionCount}} Questions {{data.mandatoryQueCount.mandatory_questions}} are Mandatory</div>
                      <div class="line-height-20"> You have already answered mandatory number of questions.</div>
                  </div>
              </v-col>
                      <v-col cols="12" sm="12">
                      <div class="right-align">
                          <v-btn @click="onClose({status:false})" class="right-btn cust-btn" color="primary">OK</v-btn>
                      </div>
                  </v-col>
          </v-row>
      </v-container>
    </div>
  </template>
  
  <script>
  
  export default {
    name: "MandatoryQuePopup",
    props: ["data", "onClose"],
    data() { return {}},
    methods: {},
  };
  </script>